import React from 'react';
import { CardActions } from '@mui/material';

import useZenMode from '../../../hooks/useZenMode';
import { CARD_ACTIONS_SX } from './styles';

/**
 * An entity card's footer strip — the metric chips and whatever action icons
 * the card offers. Gone in zen mode, which takes every card's controls.
 */
export default function CardFooter({ children }) {
  const zenMode = useZenMode();
  if (zenMode) return null;
  return (
    <CardActions disableSpacing sx={CARD_ACTIONS_SX}>
      {children}
    </CardActions>
  );
}
